<template>
    <div
        class="tile-bottom-left bg-blue-medium flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div
            class="flex flex-col flex-wrap gap-1 lg:flex-row lg:flex-nowrap lg:items-center lg:gap-8">
            <h3 class="font-title shrink-0 text-xl lg:text-2xl">{{ title }}</h3>
            <p>{{ subtitle }}</p>
        </div>
        <div class="flex shrink-0 flex-wrap gap-2">
            <NuxtLink
                v-for="(item, index) in links"
                :key="removeWhiteSpaceAndSpecialCharacters(item.title)"
                :to="localeRoute(item.url)"
                :class="index === 0 ? 'btn-primary-a' : 'btn-secondary-a'"
                >{{ item.title }}</NuxtLink
            >
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CallToActionComponentModel } from '@su4r-frontend/api';

defineProps<CallToActionComponentModel>();

const localeRoute = useLocaleRoute();
</script>
